//
// Entry point for JS
// ================================================================================

import { sessions } from './sessions.js';
import { tabs } from './tabs.js';
import { visualHeight } from './visual-height';

function autorun(){
    console.log('Scripts Loaded!');

    sessions();
    tabs();
    visualHeight();
};

if (document.addEventListener) document.addEventListener("DOMContentLoaded", autorun, false);
else if (document.attachEvent) document.attachEvent("onreadystatechange", autorun);
else window.onload = autorun;
